import d3 from 'd3';
import { isSameDay } from 'date-fns';
import React, { useMemo } from 'react';

import { IndexedTsPoint, SpxTsData } from '../BandChart.types';
import { getDirectionalArrays } from '../section-utils/section-utils';

const directionColors: Record<string, string> = {
  positive: 'var(--viz-bullish-soft)',
  negative: 'var(--viz-bearish-soft)',
};

export interface SectionAreaProps {
  ts: SpxTsData[];
  scaleX: d3.ScaleLinear<number, number>;
  y?: number;
  height: number;
  indicatorTsData?: IndexedTsPoint[];
}

export const SectionArea = ({
  ts,
  scaleX,
  height,
  y = 0,
  indicatorTsData,
}: SectionAreaProps) => {
  const sectionRanged = useMemo(() => {
    return getDirectionalArrays(ts);
  }, [ts]);

  return (
    <g data-testid="section-areas">
      {sectionRanged.map(sectionArray => {
        const firstPlotLineElement = sectionArray[0];
        const firstIndicatorElement =
          indicatorTsData?.find(point =>
            isSameDay(point.date, firstPlotLineElement.date)
          ) || firstPlotLineElement;

        const lastPlotLineElement = sectionArray[sectionArray.length - 1];
        const lastIndicatorElement =
          indicatorTsData?.find(point =>
            isSameDay(point.date, lastPlotLineElement.date)
          ) || lastPlotLineElement;

        if (firstPlotLineElement.direction) {
          return (
            <g
              transform={`translate( 0, ${-y})`}
              key={firstIndicatorElement.index}
            >
              <rect
                data-testid={`section-rect-${firstPlotLineElement.direction}`}
                x={scaleX(firstIndicatorElement.index)}
                y={0}
                width={Math.abs(
                  scaleX(
                    lastIndicatorElement.index - firstIndicatorElement.index ||
                      1
                  )
                )}
                height={Math.abs(height + y)}
                fill={directionColors[firstPlotLineElement.direction]}
                opacity={1}
                stroke="var(--background-default)"
                strokeWidth="1px"
              />
            </g>
          );
        }

        return null;
      })}
    </g>
  );
};
